export default {
  highcharts: {
    decimalPoint: ',',
    downloadJPEG: 'Pobierz obraz JPEG',
    downloadPDF: 'Pobierz dokument PDF',
    downloadPNG: 'Pobierz obraz PNG',
    downloadSVG: 'Pobierz obraz SVG',
    exportButtonTitle: 'Eksport',
    forexRate: 'Kurs średni FOREX',
    loading: 'Ładowanie...',
    months: [
      'Styczeń',
      'Luty',
      'Marzec',
      'Kwiecień',
      'Maj',
      'Czerwiec',
      'Lipiec',
      'Sierpień',
      'Wrzesień',
      'Październik',
      'Listopad',
      'Grudzień',
    ],
    printButtonTitle: 'Drukowanie',
    rangeSelectorFrom: 'Od',
    rangeSelectorTo: 'Do',
    rangeSelectorZoom: 'Przybliżenie',
    rateTypes: {
      ask: 'Najlepsza oferta sprzedaży',
      bid: 'Najlepsza oferta kupna',
      forex: 'Średni kurs na świecie',
    },
    resetZoom: 'Reset',
    resetZoomTitle: 'Reset',
    shortMonths: ['Sty', 'Lut', 'Mar', 'Kwi', 'Maj', 'Cze', 'Lip', 'Sie', 'Wrz', 'Paź', 'Lis', 'Gru'],
    thousandsSep: ' ',
    weekdays: ['Niedziela', 'Poniedziałek', 'Wtorek', 'Środa', 'Czwartek', 'Piątek', 'Sobota'],
    wtBestAsk: 'Najlepsza oferta sprzedaży',
    wtBestBid: 'Najlepsza oferta kupna',
  },
  calculator: {
    title: 'Розрахуйте свої заощадження у Walutomat',
    rangeFrom: 'Хочу',
    forBuy: 'за',
    forSell: 'на',
    directionBuy: 'При покупці',
    directionSell: 'Продаючи',
    payText: 'Ти заплатиш',
    sellText: 'ви отримаєте',
    rateText: 'Курс',
    buySelect: 'купити',
    sellSelect: 'продати',
    amountText: 'Вартість',
    includes: 'Включно',
    commission: 'з комісією {{commission}}%',
    howItWorks: '',
    banksComapreOpen: 'Порівняти з іншими',
    banksComapreClose: 'Згорнути список',
    savingsMonthly: 'З Walutomat ви можете заощадити до',
    savingsYearly: 'обмінюючи цілий рік, щомісяця.',
    conjunction: 'за один раз і',
    serverError: "Помилка зв'язку з сервером.",
    unsupportedPair: 'На даний момент ми не надаємо курси для вибраної пари валют.',
    infoError: {
      exchange: 'На Walutomat.pl ви можете безпосередньо обміняти',
      transactionFee:
        'і навпаки. Така транзакція в банку пов’язана з високою комісією, найчастіше сягає навіть 5-10% від суми обміну.',
    },
    spinnerError: 'Під час завантаження даних виникла проблема',
  },
  dashboard: {
    canEditPost: 'Możesz edytować wpis',
    postExists: 'Wpis o takim tytule już istnieje',
    postNotExists: 'Wpis o takim tytule nie istnieje',
    emptyPostTitle: 'Dodaj tytuł wpisu',
    error: 'Coś poszło nie tak :(',
  },
  widgetCalculator: {
    title: 'Перевір курси та{{nbsp}}обміняй валюту у{{nbsp}}Walutomat – швидко та{{nbsp}}вигідно.',
    actualRate: 'Актуальний курс',
    buySelect: 'Купую',
    sellSelect: 'Продаю',
    buttonText: 'Обміняти',
    exchangeAmountSellLabel: 'Ви отримаєте',
    exchangeAmountBuyLabel: 'Внесіть',
    commission: 'Промо-комісія ({{commission}}%)',
  },
  formValidation: {
    emptyField: "Обов'язкове поле",
    requiredField: "Обов'язкове поле",
    passwordToShort: 'Пароль повинен містити не менше 8 символів',
    emailNotValid: 'поле має містити правильний адрес електронної пошти',
    emailReserved: 'Даний email вже зайнятий',
    rateEmpty: 'Усі поля мають бути заповнені',
    serverUnknownError: "Помилка зв'язку з сервером.",
    invalidCharacters: 'Pole zawiera niepoprawne znaki',
    phoneNotValid: 'Numer telefonu jest niepoprawny',
    checkBoxBelow: 'Zaznacz proszę pole poniżej, aby wysłać wiadomość',
  },
  password: {
    show: 'шоу',
    hide: 'приховати',
  },
  howItWorks: {
    showButton: 'показати більше',
    hideButton: 'показувати менше',
  },
}
